// fetch client withdrawals
export const FETCH_CLIENT_MM_WITHDRAWALS_REQUESTED = "FETCH_CLIENT_MM_WITHDRAWALS_REQUESTED";
export const FETCH_CLIENT_MM_WITHDRAWALS_SUCCESS = "FETCH_CLIENT_MM_WITHDRAWALS_SUCCESS";
export const FETCH_CLIENT_MM_WITHDRAWALS_FAIL = "FETCH_CLIENT_MM_WITHDRAWALS_FAIL";

export const UNSUBSCRIBE_STRATEGY = "UNSUBSCRIBE_STRATEGY";
export const UNSUBSCRIBE_STRATEGY_SUCCESS = "UNSUBSCRIBE_STRATEGY_SUCCESS";
export const UNSUBSCRIBE_STRATEGY_FAIL = "UNSUBSCRIBE_STRATEGY_FAIL";
